import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-pagination',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
    @Input() currentPage = 1;
    @Input() totalPages = 1;
    @Input() totalItems?: number;
    @Input() pageSize?: number;

    @Output() pageChange = new EventEmitter<number>();

    get computedTotalPages(): number {
        if (this.totalItems !== undefined && this.pageSize) {
            return Math.ceil(this.totalItems / this.pageSize) || 1;
        }
        return this.totalPages || 1;
    }

    get paginationRange(): number[] {
        const pages: number[] = [];
        for (let i = 1; i <= this.computedTotalPages; i++) {
            pages.push(i);
        }
        return pages;
    }

    goToPage(page: number): void {
        if (page < 1 || page > this.computedTotalPages || page === this.currentPage) {
            return;
        }
        this.pageChange.emit(page);
    }
}
